import { Component, ViewChild, Input, Inject, AfterViewInit, OnInit, EventEmitter, DOCUMENT } from '@angular/core';
import { environment } from '../../../environments/environment';

import { GenericService } from '../../../common/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { DatePipe } from '@angular/common';
import { DataService } from '../../../common/data.service';
import { HttpClient, HttpResponse, HttpRequest, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LazyLoadingService } from '../../../common/lazyloading';
import { DxDataGridComponent } from 'devextreme-angular/ui/data-grid';
import { FAScoringModelQualitativeView, APIParam, QualitativeGroup } from '../WFScoringQualitativeDetail/WFScoringQualitativeDetail.model'
import { JSONCurrentInstanceData } from '../../WorkflowDashBoard.model';
import { UtilityService } from '../../../common/utility.service';


@Component({
    selector: 'app-ScoringQualitativeDetail-Component',
    templateUrl: './WFScoringQualitativeDetail.component.html',
    styleUrls: ['./WFScoringQualitativeDetail.component.css'],
    outputs: ['onInitialized'],
    standalone: false
})
///Component can be integrated with parent component 
export class ScoringQualitativeDetail implements OnInit {

  

  public documentURL: string;
  public urlAarray: string[];
  public baseURL: string;
  public hostname: string;
  public __sGetApiUrl: string = this.__oUtilityService.GetBasewebAPIURL();
  public userName: string;
  public __oInstanceAllStateData: JSONCurrentInstanceData[] = [];
  public __sScoringModelName: string = '';
  public __oQualitativeGroup: QualitativeGroup[] = [];
  public __bIsLoadingVisible: boolean = false;


  onInitialized = new EventEmitter<ScoringQualitativeDetail>();

  @Input()
  __sInstanceId: number = 0;

  @Input()
  __sStateDataId: number = 0;

  @Input()
  __sValue: any = "";

  @Input()
  __sDataCaption: string = "";

  @Input()
  __sQualitativeControlState: string = "";

  @Input()
  __sScoringModel: string = "";

  @Input()
  __sTradingCounterparty: string = "";

  @Input()
  __bReadOnly: number = 0;

  @Input()
  __sQualitativeControl: string = "";

  public __oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];

  constructor(@Inject(DOCUMENT) public document: any, public service: GenericService, public route: ActivatedRoute, public router: Router, public data: DataService, public http: HttpClient, public __oUtilityService: UtilityService, public datePipe: DatePipe, public lazyLoadingService: LazyLoadingService) {
    

  }

  // fires on post view renders
  ngAfterViewInit(): void {
  }

  // fires on initialization
  ngOnInit() {
    this.onInitialized.emit(this);

  } 

  /// Events

  public TextAreaOnChange(e: any) {

    let oExistFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(x => x.lFAScoringModelQualitativeId == e);

    if (oExistFAScoringModelQualitativeView.IsScored == 1) {
      this.__bIsLoadingVisible = true;
      this.service.UpdateAllDataByPromise(oExistFAScoringModelQualitativeView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateQualitativeFactorScore").then(
        result => this.OnSuccessGetFAScoringModelQualitativeForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelQualitative(error))
    }

  }

  public TextAreaOnChangeOriginal(e: any) {

    let oExistFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(x => x.lFAScoringModelQualitativeId == e);

    if (this.__sQualitativeControlState == 'Not Approve State' && this.__bReadOnly == 0)
      oExistFAScoringModelQualitativeView.AdjustedValue = oExistFAScoringModelQualitativeView.OriginalValue;

    if (oExistFAScoringModelQualitativeView.IsScored == 1) {
      this.__bIsLoadingVisible = true;
      this.service.UpdateAllDataByPromise(oExistFAScoringModelQualitativeView, this.__sGetApiUrl + "api/WorkflowDashBoard/PutCalculateQualitativeFactorScore").then(
        result => this.OnSuccessGetFAScoringModelQualitativeForNewScore(result)
      ).
        catch(error => this.OnErrorGetFAScoringModelQualitative(error))
    }

  }

  /// component public methods can be called from parent component

  public Refresh() {

    //console.log(this.__sInstanceId);
    //console.log(this.__sStateDataId);
    //console.log(this.__sValue);
    //console.log(this.__sDataCaption);
    this.__bIsLoadingVisible = true;
    
      this.service.getDataByPromise(this.__sGetApiUrl + "api/WorkflowDashBoard/GetBusinessProcessInstanceAllStateData/" + this.__sInstanceId).then((Data) => {

        if (Data != null) {

          let sData: string = Data;

          sData = sData.replace(/\n/g, 'neewwlliine').replace(/\r/g, 'neewwlliine');
          //sData = this.replaceAllSpecialCharacters(sData);

          try {
            this.__oInstanceAllStateData = JSON.parse(sData);

            for (let oFSV of this.__oInstanceAllStateData) {
              if (oFSV.DataValue != undefined || oFSV.DataValue != null)
                oFSV.DataValue = this.replaceAllSpecialCharacters(oFSV.DataValue);
            }​​​

            this.__sScoringModelName = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sScoringModel).DataValue;

            let oAPIParam: APIParam = new APIParam();
            oAPIParam.Param = this.__sScoringModelName;
            oAPIParam.sTradingcounterparty = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sTradingCounterparty).DataValue;

            if (!this.IsNullOrEmpty(this.__sQualitativeControl) && (this.IsNullOrEmpty(this.__sValue) || this.__sValue == undefined ))
            {
              this.__sValue = this.__oInstanceAllStateData.find(x => x.DataCaption == this.__sQualitativeControl).DataValue;
            }

            if (this.IsNullOrEmpty(this.__sValue)) {
              oAPIParam.sValue = "All";
            }
            else {
              oAPIParam.sValue = "Plain";
            }

            this.service.UpdateAllDataByPromise(oAPIParam, this.__sGetApiUrl + "api/WorkflowDashBoard/PutFAScoringModelQualitativeView").then(
              result => this.OnSuccessGetFAScoringModelQualitative(result)
            ).
              catch(error => this.OnErrorGetFAScoringModelQualitative(error))

          }
          catch
          {
            console.log(sData);
            this.__bIsLoadingVisible = false;
          }          

        }

      });
    


  }



  public GetData() {
    let sXML: string = '';

    sXML += '<QualitativeData>';
    sXML += '<ScoringModel>' + this.__sScoringModelName + '</ScoringModel>';
      

    for (let x of this.__oFAScoringModelQualitativeView)
    {
      sXML += '<Data>';
      sXML += '<QualitativeFactor>' + x.QualitativeFactor + "</QualitativeFactor>";

      if (!this.IsNullOrUndefined(x.OriginalValue)) {
        sXML += "<OriginalValue>" + x.OriginalValue + "</OriginalValue>";
      }
      else {
        sXML += "<OriginalValue></OriginalValue>";
      }

      if (!this.IsNullOrUndefined(x.AdjustedValue)) {
        sXML += '<AdjustedValue>' + x.AdjustedValue + "</AdjustedValue>";
      }
      else {
        sXML += "<AdjustedValue></AdjustedValue>";
      }

      if (!this.IsNullOrUndefined(x.Score)) {
        sXML += '<Score>' + x.Score + "</Score>";
      }
      else {
        sXML += "<Score></Score>";
      }

      if (!this.IsNullOrUndefined(x.Weight)) {
        sXML += '<Weight>' + x.Weight + "</Weight>";
      }
      else {
        sXML += "<Weight></Weight>";
      }

      if (!this.IsNullOrUndefined(x.WeightedScore)) {
        sXML += '<WeightedScore>' + x.WeightedScore + "</WeightedScore>";
      }
      else {
        sXML += "<WeightedScore></WeightedScore>";
      }



      //sXML += '<OriginalValue>' + x.OriginalValue + "</OriginalValue>";
      //sXML += '<AdjustedValue>' + x.AdjustedValue + "</AdjustedValue>";
      //sXML += '<Score>' + x.Score + "</Score>";      
      //sXML += '<Weight>' + x.Weight + "</Weight>";
      //sXML += '<WeightedScore>' + x.WeightedScore + "</WeightedScore>";
      sXML += '</Data>';   
    }

    //let sJSONText:string = "";    

    //for (let x of this.__oFAScoringModelQualitativeView)
    //{
    //  if (this.IsNullOrEmpty(sJSONText)) {
    //    sJSONText += "{\"QualitativeFactor\":" + "\"" + x.QualitativeFactor + "\",\"AdjustedValue\":" + "\"" + x.AdjustedValue + "\" }";
    //  }
    //  else {
    //    sJSONText += ", {\"QualitativeFactor\":" + "\"" + x.QualitativeFactor + "\",\"AdjustedValue\":" + "\"" + x.AdjustedValue + "\" }";
    //  }

    //}

    //sJSONText = "[" + sJSONText + "]";

    //sXML = sXML.replace("JSONText",sJSONText);

    sXML += '</QualitativeData>';
    return sXML;
  }

  public OnErrorGetFAScoringModelQualitative(error: any)
  {
    console.log(error);
    this.__bIsLoadingVisible = false;
  }
  public OnSuccessGetFAScoringModelQualitative(response: any) {

    if (response != null) {
      let oFAScoringModelQualitativeView: FAScoringModelQualitativeView[] = [];
      oFAScoringModelQualitativeView = response;

      this.__oQualitativeGroup = [];

      for (let x of oFAScoringModelQualitativeView) {
        if (!this.IsNullOrEmpty(x.GroupName) && x.GroupName != 'CRating' && x.GroupName != 'PRating') {
          if (this.__oQualitativeGroup.find(y => y.GroupName == x.GroupName) == null) {
            let oQualitativeGroup: QualitativeGroup = new QualitativeGroup();
            oQualitativeGroup.GroupName = x.GroupName;
            this.__oQualitativeGroup.push(oQualitativeGroup);
          }
        }

        if (x.CustomPropertyDisplayType == 'Combo Box') {
          if (!this.IsNullOrEmpty(x.ItemSource)) {
            x.ItemSourceJSON = JSON.parse(x.ItemSource);
          }

        }

      }


      this.__oFAScoringModelQualitativeView = oFAScoringModelQualitativeView;


      if (!this.IsNullOrEmpty(this.__sValue)) {
        let sXML: string = this.__sValue;

        sXML = sXML.replace('<QualitativeData>', '');
        sXML = sXML.replace('</QualitativeData>', '');

        let iDefinitionStartIndex: number = 0;
        let iDefinitionLastIndex: number = 0;
        let sColumnData: string = "";


        iDefinitionStartIndex = sXML.indexOf("<ScoringModel>");
        iDefinitionLastIndex = sXML.indexOf("</ScoringModel>");

        sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 15);

        let sScoringModel: string = sColumnData.replace("<ScoringModel>", "").replace("</ScoringModel>", "");

        sXML = sXML.replace(sColumnData, '');

        if (sScoringModel == this.__sScoringModelName) {

          let oQualitativeColumns: string[] = ['QualitativeFactor', 'OriginalValue', 'AdjustedValue', 'Score', 'Weight', 'WeightedScore'];

          let iStartIndex: number = 0;
          let iLastIndex: number = 0;
          let sXMLData: string = '';
          let sNode: string = '';
          let iColumnStartIndex: number = 0;
          let iColumnLastIndex: number = 0;
          let sColumnValue: string = "";
          let sValue: any = "";
          let sData: string = '';

          let oQualitativeFactors: any[] = [];

          while (sXML.trim() != '') {
            let oQualitativeFactor: any = {};

            iStartIndex = sXML.indexOf("<Data>");
            iLastIndex = sXML.indexOf("</Data>");

            sXMLData = sXML.substring(iStartIndex, iLastIndex + 7);

            sNode = sXMLData.replace("<Data>", "").replace("</Data>", "");

            for (let oColumn of oQualitativeColumns) {
              iColumnStartIndex = sNode.indexOf("<" + oColumn + ">");

              if (iColumnStartIndex >= 0) {
                iColumnLastIndex = sNode.indexOf("</" + oColumn + ">");

                sColumnValue = sNode.substring(iColumnStartIndex, iColumnLastIndex + ("</" + oColumn + ">").length);

                sValue = sColumnValue.replace("<" + oColumn + ">", "").replace("</" + oColumn + ">", "");

              }

              switch (oColumn) {
                case 'QualitativeFactor':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.QualitativeFactor = sValue;
                    }
                    break;
                  }
                case 'OriginalValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.OriginalValue = sValue;
                    }
                    break;
                  }
                case 'AdjustedValue':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.AdjustedValue = sValue;
                    }
                    break;
                  }
                case 'Score':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Score = Number(sValue);
                    }
                    break;
                  }
                case 'Weight':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.Weight = Number(sValue);
                    }
                    break;
                  }
                case 'WeightedScore':
                  {
                    if (sValue != 'null') {
                      oQualitativeFactor.WeightedScore = Number(sValue);
                    }
                    break;
                  }

              }
            }

            sXML = sXML.replace(sXMLData, '');
            oQualitativeFactors.push(oQualitativeFactor);

          }


          for (let x of oQualitativeFactors) {
            let oFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(y => y.QualitativeFactor == x.QualitativeFactor);

            if (oFAScoringModelQualitativeView != null) {

              oFAScoringModelQualitativeView.OriginalValue = x.OriginalValue;
              oFAScoringModelQualitativeView.AdjustedValue = x.AdjustedValue;
              oFAScoringModelQualitativeView.Score = x.Score;
              oFAScoringModelQualitativeView.Weight = x.Weight;
              oFAScoringModelQualitativeView.WeightedScore = x.WeightedScore;


            }

            //iDefinitionStartIndex = sXML.indexOf("<Data>");
            //iDefinitionLastIndex = sXML.indexOf("</Data>");

            //sColumnData = sXML.substring(iDefinitionStartIndex, iDefinitionLastIndex + 7);

            //let sJson: string = sColumnData.replace("<Data>", "").replace("</Data>", "");

            //sJson = sJson.replace(/doouubleQuote/g, '"');

            //let oQF: any = JSON.parse(sJson);

            //for (let x of oQF)
            //{
            //  let oFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(y => y.QualitativeFactor == x.QualitativeFactor);

            //  if (oFAScoringModelQualitativeView != null) {

            //    if (x.AdjustedValue != 'null')
            //      oFAScoringModelQualitativeView.AdjustedValue = x.AdjustedValue;

            //    if (oFAScoringModelQualitativeView.IsScored == 1) {

            //      this.TextAreaOnChange(oFAScoringModelQualitativeView.lFAScoringModelQualitativeId);

            //    }


            //  }

            //}


          }

        }

      }

    }
    this.__bIsLoadingVisible = false;
  }

  public OnSuccessGetFAScoringModelQualitativeForNewScore(response: any) {

    if (response != null) {
      let oFAScoringModelQualitativeView: FAScoringModelQualitativeView = response;

      let oExistFAScoringModelQualitativeView: FAScoringModelQualitativeView = this.__oFAScoringModelQualitativeView.find(x => x.lFAScoringModelQualitativeId == oFAScoringModelQualitativeView.lFAScoringModelQualitativeId);

      if (!this.IsNullOrUndefined(oExistFAScoringModelQualitativeView))
      {
        oExistFAScoringModelQualitativeView.Score = oFAScoringModelQualitativeView.Score;
        oExistFAScoringModelQualitativeView.WeightedScore = oExistFAScoringModelQualitativeView.Score * oExistFAScoringModelQualitativeView.Weight;
      }

    }
    this.__bIsLoadingVisible = false;
  }


  public replaceAll(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/:/g, 'cln100').replace(/&/g, 'annnd').replace(/\+/g, 'pluuus').replace(/\//g, 'backslaaash')
      .replace(/</g, 'leeesthan').replace(/>/g, 'greeeterthan').replace(/:/g, 'cln100').replace(/\\/g, 'bckwrdslsh101'); //.replace(/\\n/g, 'newline').replace(/\\r/g, 'newline').replace(/\\t/g, 'newline');
    return strToBeReturned;
  }

  public replaceFilePath(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/\\/g, 'bckwrdslsh101').replace(/:/g, 'cln100');
    return strToBeReturned;
  }

  public URLEncode(str: any) {
    let strToBeReturned = "";
    strToBeReturned = str.replace(/&/g, '%26');
    return strToBeReturned;
  }



  public IsNullOrEmpty(sValue: string) {
    if (sValue == undefined || sValue == '' || sValue == null || sValue.trim() == '') {
      return true;
    }
    else {
      return false;
    }
  }

  public IsNullOrUndefined(iValue: any) {
    if (iValue == undefined || iValue == null) {
      return true;
    }
    else {
      return false;
    }
  }

  public IsTrue(oValue: any) {
    if (oValue != undefined && (oValue == 1 || oValue.toString() == 'true')) {
      return true;
    }
    else {
      return false;
    }
  }
  private replaceAllSpecialCharacters(str: any) {
    let strToBeReturned = "";

    strToBeReturned = str.replace(/backslaaash/g, "\\\\").replace(/annnd/g, "&").replace(/pluuuus/g, "+").replace(/cln100/g, ":").replace(/leeesthan/g, "<").replace(/greeeterthan/g, ">").replace(/hassh/g, "#")
      .replace(/aaat/g, "@").replace(/staaar/g, "*").replace(/dolllaar/g, "$").replace(/perseent/g, "%").replace(/exclammmaation/g, "!").replace(/quoootes/g, '"').replace(/ampersand/g, "&"); //FB 30669 - Vidya

    return strToBeReturned;
  }

}
